import { Text } from '@yes.technology/react-toolkit'
import YouTube from 'react-youtube'
import { Container } from './styles'
import useYouTubeEmbed from './useYouTubeEmbed/useYouTubeEmbed'
import { VideoProps } from './Video.types'

const Video = ({ props: { videoId, startSeconds = 0 } }: VideoProps) => {
  const { ytProps, title, duration, currentTime } = useYouTubeEmbed({
    videoId,
    startSeconds,
    onPlayPauseLog: (event) => {
      console.log(`[${event.action.toUpperCase()}]`, {
        time: new Date(event.timestamp).toISOString(),
        videoTime: event.currentTime
      })
    }
  })

  return (
    <Container>
      <YouTube {...ytProps} />
      {title && <Text variant='content-emphasis-04'>Título: {title}</Text>}
      <Text variant='content-emphasis-04'>Duração: {duration}s</Text>
      <Text variant='content-emphasis-04'>Tempo atual: {currentTime}s</Text>
    </Container>
  )
}

export default Video
